export enum ETipoApresentacaoMenu {
    Padrao = 1,
    CardQuadrado = 2,
    CardRetangular = 3
}
